import { Grid, Paper, Text } from '@mantine/core'

import classes from './Notes.module.css'

export const Notes = ({
  notes,
  showNotes,
}: {
  notes: string | undefined | null
  showNotes: boolean
}) => {
  if (!showNotes || !notes) {
    return <></>
  }
  return (
    <Grid.Col span={12}>
      <Text className={classes.noteTitle}>Last Note</Text>
      <Paper className={classes.notes}>
        {notes?.split('\n').map((line, index) => (
          <Text key={index} c='dark'>
            {line}
          </Text>
        ))}
      </Paper>
    </Grid.Col>
  )
}
